import React from 'react';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto" style={{ backgroundColor: '#FBFAF7' }}>
      <div className="container mx-auto px-6 py-12">
        <div className="max-w-[880px] mx-auto text-center">
          {/* Privacy Statement */}
          <p className="text-sm mb-6 leading-relaxed" style={{ color: 'rgba(34, 34, 34, 0.6)' }}>
            Your journal entries are encrypted and private. You can export or delete them at any time.
          </p>

          {/* Links */}
          <div className="flex flex-wrap justify-center items-center gap-4 text-sm mb-8">
            <a
              href="/privacy"
              className="hover:underline"
              style={{ color: '#4E8F6C' }}
            >
              Privacy Policy
            </a>
            <span style={{ color: 'rgba(34, 34, 34, 0.3)' }}>•</span>
            <a
              href="/terms"
              className="hover:underline"
              style={{ color: '#4E8F6C' }}
            >
              Terms of Service
            </a>
            <span style={{ color: 'rgba(34, 34, 34, 0.3)' }}>•</span>
            <a
              href="/support"
              className="hover:underline"
              style={{ color: '#4E8F6C' }}
            >
              Support
            </a>
            <span style={{ color: 'rgba(34, 34, 34, 0.3)' }}>•</span>
            <a
              href="mailto:hello@edenpages.com"
              className="hover:underline"
              style={{ color: '#4E8F6C' }}
            >
              Contact
            </a>
          </div>

          {/* Copyright */}
          <p className="text-xs" style={{ color: 'rgba(34, 34, 34, 0.4)' }}>
            © {currentYear} Eden Pages. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
